import http from "@/apps/shared/baseService/config";

const base = {
  rota: "estoques",
  nome: "estoques",
  contexto: "admin"
};

export const service = {
  criar: data => http.post(`/admin/${base.rota}/create`, data),
  listar: data => http.post(`/admin/${base.rota}/list`, data),
  atualizar: data => http.post(`/admin/${base.rota}/update`, data),
  excluir: data => http.post(`/admin/${base.rota}/delete`, data)
};

const module = {
  actions: {
    listar_estoques: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .listar(getters.get_estoques_filtros)
        .then(res => {
          dispatch("disableLoading");
          commit("set_estoques", res.data);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    atualizar_estoque: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .atualizar({
          ...getters.get_estoque,
          imagens: getters.getLinks,
          links: getters.getFiles
        })
        .then(res => {
          dispatch("disableLoading");
          commit("set_estoque", res.data);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Atualização Concluída!",
            timeout: 6000
          });
          dispatch("listar_estoques");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    criar_estoque: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .criar({
          ...getters.get_estoque,
          funcionario: getters.getLoggedUser,
          imagens: getters.getLinks,
          links: getters.getFiles
        })
        .then(() => {
          dispatch("disableLoading");
          // commit("set_estoque", {});
          // commit("setLinks", []);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Registrado",
            timeout: 6000
          });
          dispatch("listar_estoques");
          commit("set_modal_view_estoque", false);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    excluir_estoque: ({ dispatch, getters }, payload) => {
      dispatch("enableLoading");
      service
        .excluir(payload)
        .then(() => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Exclusão Concluída!",
            timeout: 6000
          });
          dispatch("listar_estoques");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    excluir_estoques: ({ dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .excluir(getters.get_estoques_marcados)
        .then(() => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Exclusão em massa Concluída!",
            timeout: 6000
          });
          dispatch("listar_estoques");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    abre_modal_view_estoque: ({ commit, getters, dispatch }, payload) => {
      if (payload) {
        commit("set_estoque", payload);
        commit("setLinks", payload.imagens);
      }
      commit("set_modal_view_estoque", true);
    },
    fecha_modal_view_estoque: ({ commit }) => {
      commit("set_estoque", {});
      commit("setLinks", []);
      commit("set_modal_view_estoque", false);
    },
    add_estoque_marcado: ({ commit, getters }, payload) => {
      commit("set_estoques_marcados", [
        ...getters.get_estoques_marcados,
        payload
      ]);
    },
    remove_estoque_marcado: ({ commit, getters }, i) => {
      commit(
        "set_estoques_marcados",
        ...getters.get_estoques_marcados.filter((item, index) => index !== i)
      );
    }
  },
  state: {
    estoque: {},
    estoques: {
      docs: [],
      page: 1,
      totalPages: 1
    },
    estoques_marcados: [],
    estoques_filtros: {
      limitPerPage: 10,
      page: 1,
      dataInicio: "",
      dataFim: ""
    },
    modal_view_estoque: false
  },
  mutations: {
    set_estoque: (state, payload) => (state.estoque = payload),
    set_estoques: (state, payload) => (state.estoques = payload),
    set_estoques_marcados: (state, payload) =>
      (state.estoques_marcados = payload),
    set_modal_view_estoque: (state, payload) =>
      (state.modal_view_estoque = payload)
  },
  getters: {
    get_estoque: state => state.estoque,
    get_estoques: state => state.estoques,
    get_estoques_marcados: state => state.estoques_marcados,
    get_modal_view_estoque: state => state.modal_view_estoque,
    get_estoques_filtros: state => state.estoques_filtros
  }
};

const routes = [
  {
    path: `/${base.rota}`,
    component: () => import("./views/Listar.vue"),
    name: base.nome
  }
];

export default {
  service,
  module,
  routes
};
